import React from 'react';
import { Button } from '@material-tailwind/react';
import { MaterialButtonProps } from '../../utils/global';

const SuccessButton: React.FC<MaterialButtonProps> = ({
  children,
  onClick,
  size = 'sm',
  className = '',
  type = 'button',
  disabled = false,
}) => {
  return (
    <Button
      size={size}
      type={type}
      disabled={disabled}
      className={`bg-[var(--buttonSuccess)] hover:bg-[var(--buttonSuccessHover)] text-[var(--text)] flex items-center ${className}`}
      onClick={onClick}
      placeholder={undefined}
      onResize={undefined}
      onResizeCapture={undefined}
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
    >
      {children}
    </Button>
  );
};

export default SuccessButton;
